import React from "react";

import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import BrandedSuccessLottie from "@/components/ui/BrandedSuccessLottie";
import { useAuth } from "@/context/auth-context";
import { userNeedsSignUpBusinessDetails } from "@/pages/SignUp/verifyAccountSteps";
import { useVerifyAccountStep } from "@/pages/SignUp/useVerifyAccountStep";
import { Button } from "../../ui/button/button";

type Props = {
	isOpen?: boolean;
	onOpenChange: (open: boolean) => void;
};
const SuccessModel: React.FC<Props> = ({ isOpen = false, onOpenChange }) => {
	const { setStep } = useVerifyAccountStep();
	const { user } = useAuth();

	return (
		<Dialog open={isOpen} onOpenChange={onOpenChange}>
			<DialogContent className="max-w-[800px] text-center w-[calc(100%-48px)] rounded-[40px] block [&>button]:hidden">
				<DialogHeader>
					<DialogTitle className="pt-[70px] text-center font-bold text-4xl text-textDark">
						<p>Great job!</p>
						<p>Your account is now set up.</p>
					</DialogTitle>
				</DialogHeader>
				<div className="mt-6 text-center">
					<p className="text-sm font-medium text-textLight">
						Way to go! Now let's secure your account.
					</p>
				</div>
				<div className="max-w-80 mx-auto">
					<BrandedSuccessLottie
						rendererSettings={{
							preserveAspectRatio: "xMidYMid slice",
						}}
					/>
				</div>

				<DialogFooter>
					<Button
						data-testid={"account-setup-continue-button"}
						type="submit"
						className="w-full"
						onClick={() => {
							setStep(
								userNeedsSignUpBusinessDetails(user)
									? "business_details"
									: "pin",
							);
						}}
					>
						Continue
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default SuccessModel;
